"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const data_1 = require("./data");
const wallet_1 = require("./wallet");
class Client {
    constructor(rpcUrl) {
        this.rpcUrl = rpcUrl;
    }
    get(path, params) {
        return __awaiter(this, void 0, void 0, function* () {
            let options;
            if (params)
                options = { params };
            const response = yield axios_1.default.get(`${this.rpcUrl}${path}`, options);
            return response.data;
        });
    }
    post(path, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(`${this.rpcUrl}${path}`, data);
            return response.data;
        });
    }
    getResult(path, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.get(`${path}`, params);
            return response.result;
        });
    }
    postResult(path, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.post(`${path}`, data);
            return response.result;
        });
    }
    getChainID() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.get('/bandchain/chain_id');
            return response.chain_id;
        });
    }
    getLatestBlock() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.get('/blocks/latest');
            const header = response.block.header;
            return {
                block: {
                    header: {
                        chainID: header.chain_id,
                        height: parseInt(header.height),
                        time: Math.floor(new Date(header.time).getTime() / 1000),
                        lastCommitHash: Buffer.from(header.last_commit_hash, 'hex'),
                        dataHash: Buffer.from(header.data_hash, 'hex'),
                        validatorsHash: Buffer.from(header.validators_hash, 'hex'),
                        nextValidatorsHash: Buffer.from(header.next_validators_hash, 'hex'),
                        consensusHash: Buffer.from(header.consensus_hash, 'hex'),
                        appHash: Buffer.from(header.app_hash, 'hex'),
                        lastResultsHash: Buffer.from(header.last_results_hash, 'hex'),
                        evidenceHash: Buffer.from(header.evidence_hash, 'hex'),
                        proposerAddress: Buffer.from(header.proposer_address, 'hex'),
                    },
                },
                blockID: { hash: Buffer.from(response.block_id.hash, 'hex') },
            };
        });
    }
    getDataSource(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Number.isInteger(id))
                throw Error('id is not an integer');
            const response = yield this.getResult(`/oracle/data_sources/${id}`);
            return {
                owner: wallet_1.Address.fromAccBech32(response.owner),
                name: response.name,
                description: response.description,
                fileName: response.filename,
            };
        });
    }
    getAccount(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getResult(`/auth/accounts/${address.toAccBech32()}`);
            const value = response.value;
            if (!value.address)
                return;
            return {
                address: wallet_1.Address.fromAccBech32(value.address),
                coins: value.coins.map((c) => new data_1.Coin(c.amount, c.denom)),
                publicKey: value.public_key,
                accountNumber: parseInt(value.account_number),
                sequence: parseInt(value.sequence),
            };
        });
    }
    getOracleScript(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Number.isInteger(id))
                throw Error('id is not an integer');
            const response = yield this.getResult(`/oracle/oracle_scripts/${id}`);
            return {
                owner: wallet_1.Address.fromAccBech32(response.owner),
                name: response.name,
                description: response.description,
                fileName: response.filename,
                schema: response.schema,
                sourceCodeUrl: response.source_code_url,
            };
        });
    }
    sendTxSyncMode(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.post('/txs', {
                tx: data,
                mode: 'sync',
            });
            let code = 0;
            let errorLog;
            if (response.code) {
                code = parseInt(response.code);
                errorLog = response.raw_log;
            }
            return {
                txHash: Buffer.from(response.txhash, 'hex'),
                code,
                errorLog,
            };
        });
    }
    sendTxAsyncMode(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let respose = yield this.post('/txs', {
                tx: data,
                mode: 'async',
            });
            return {
                txHash: Buffer.from(respose.txhash, 'hex'),
            };
        });
    }
    sendTxBlockMode(data) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.post('/txs', {
                tx: data,
                mode: 'block',
            });
            let code = 0;
            let errorLog;
            let log = [];
            if (response.code) {
                code = parseInt(response.code);
                errorLog = response.raw_log;
            }
            else {
                log = response.logs;
            }
            return {
                height: parseInt(response.height),
                txHash: Buffer.from(response.txhash, 'hex'),
                gasWanted: parseInt(response.gas_wanted),
                gasUsed: parseInt(response.gas_wanted),
                code,
                log,
                errorLog,
            };
        });
    }
    getReferenceData(pairs) {
        return __awaiter(this, void 0, void 0, function* () {
            let symbolSet = new Set();
            pairs.forEach((pair) => {
                let symbols = pair.split('/');
                symbols.forEach((symbol) => {
                    if (symbol === 'USD')
                        return;
                    symbolSet.add(symbol);
                });
            });
            let symbolList = Array.from(symbolSet);
            let pricerBody = {
                symbols: symbolList,
                min_count: 10,
                ask_count: 16,
            };
            let priceData = yield this.postResult('/oracle/request_prices', pricerBody);
            let symbolMap = {};
            symbolMap['USD'] = {
                symbol: 'USD',
                multiplier: '1000000000',
                px: '1000000000',
                request_id: 0,
                resolve_time: Math.floor(Date.now() / 1000).toString(),
            };
            priceData.map((price) => {
                symbolMap[price.symbol] = price;
            });
            let data = [];
            pairs.forEach((pair) => {
                let [baseSymbol, quoteSymbol] = pair.split('/');
                data.push({
                    pair,
                    rate: (Number(symbolMap[baseSymbol].px) *
                        Number(symbolMap[quoteSymbol].multiplier)) /
                        (Number(symbolMap[quoteSymbol].px) *
                            Number(symbolMap[baseSymbol].multiplier)),
                    updatedAt: {
                        base: Number(symbolMap[baseSymbol].resolve_time),
                        quote: Number(symbolMap[quoteSymbol].resolve_time),
                    },
                    requestID: {
                        base: Number(symbolMap[baseSymbol].request_id),
                        quote: Number(symbolMap[quoteSymbol].request_id),
                    },
                });
            });
            return data;
        });
    }
    getReporters(validator) {
        return __awaiter(this, void 0, void 0, function* () {
            let response = yield this.getResult(`/oracle/reporters/${validator.toValBech32()}`);
            return response.map((a) => wallet_1.Address.fromAccBech32(a));
        });
    }
    getPriceSymbols(minCount, askCount) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Number.isInteger(minCount))
                throw Error('minCount is not an integer');
            if (!Number.isInteger(askCount))
                throw Error('askCount is not an integer');
            let response = yield this.getResult('/oracle/price_symbols', {
                min_count: minCount,
                ask_count: askCount,
            });
            return response;
        });
    }
    getLatestRequest(oid, calldata, minCount, askCount) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!Number.isInteger(oid))
                throw Error('oid is not an integer');
            if (!Number.isInteger(minCount))
                throw Error('minCount is not an integer');
            if (!Number.isInteger(askCount))
                throw Error('askCount is not an integer');
            const response = yield this.getResult(`/oracle/request_search`, {
                params: {
                    oid: oid,
                    calldata: calldata.toString('base64'),
                    min_count: minCount,
                    ask_count: askCount,
                },
            });
            return {
                request: {
                    oracleScriptID: parseInt(response.request.oracle_script_id),
                    requestedValidators: response.request.requested_validators,
                    minCount: parseInt(response.request.min_count),
                    requestHeight: parseInt(response.request.request_height),
                    clientID: response.request.client_id ? response.request.client_id : '',
                    calldata: response.request.calldata
                        ? Buffer.from(response.request.calldata, 'base64')
                        : Buffer.from(''),
                    rawRequests: response.request.raw_requests.map((request) => {
                        return {
                            externalID: request.external_id
                                ? parseInt(request.external_id)
                                : 0,
                            dataSourceID: parseInt(request.data_source_id),
                            calldata: request.calldata
                                ? Buffer.from(request.calldata, 'base64')
                                : Buffer.from(''),
                        };
                    }),
                },
                reports: (_a = response.reports) === null || _a === void 0 ? void 0 : _a.map((report) => {
                    return {
                        validator: report.validator,
                        inBeforeResolve: !!report.in_before_resolve,
                        rawReports: report.raw_reports.map((rawReport) => {
                            return {
                                externalID: rawReport.external_id
                                    ? parseInt(rawReport.external_id)
                                    : 0,
                                data: rawReport.data
                                    ? Buffer.from(rawReport.data, 'base64')
                                    : Buffer.from(''),
                            };
                        }),
                    };
                }),
                result: response.result && {
                    requestPacketData: {
                        clientID: response.result.request_packet_data.client_id
                            ? response.result.request_packet_data.client_id
                            : '',
                        askCount: parseInt(response.result.request_packet_data.ask_count),
                        minCount: parseInt(response.result.request_packet_data.min_count),
                        oracleScriptID: parseInt(response.result.request_packet_data.oracle_script_id),
                        calldata: response.result.request_packet_data.calldata
                            ? Buffer.from(response.result.request_packet_data.calldata, 'base64')
                            : Buffer.from(''),
                    },
                    responsePacketData: {
                        requestID: parseInt(response.result.response_packet_data.request_id),
                        requestTime: parseInt(response.result.response_packet_data.request_time),
                        resolveTime: parseInt(response.result.response_packet_data.resolve_time),
                        resolveStatus: response.result.response_packet_data.resolve_status,
                        ansCount: response.result.response_packet_data.ans_count
                            ? parseInt(response.result.response_packet_data.ans_count)
                            : 0,
                        clientID: response.result.response_packet_data.client_id
                            ? response.result.response_packet_data.client_id
                            : '',
                        result: response.result.response_packet_data.result
                            ? Buffer.from(response.result.response_packet_data.result, 'base64')
                            : Buffer.from(''),
                    },
                },
            };
        });
    }
    getRequestByID(id) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (!Number.isInteger(id))
                throw Error('id is not an integer');
            const response = yield this.getResult(`/oracle/requests/${id}`);
            return {
                request: {
                    oracleScriptID: parseInt(response.request.oracle_script_id),
                    requestedValidators: response.request.requested_validators,
                    minCount: parseInt(response.request.min_count),
                    requestHeight: parseInt(response.request.request_height),
                    clientID: response.request.client_id ? response.request.client_id : '',
                    calldata: response.request.calldata
                        ? Buffer.from(response.request.calldata, 'base64')
                        : Buffer.from(''),
                    rawRequests: response.request.raw_requests.map((request) => {
                        return {
                            externalID: request.external_id
                                ? parseInt(request.external_id)
                                : 0,
                            dataSourceID: parseInt(request.data_source_id),
                            calldata: request.calldata
                                ? Buffer.from(request.calldata, 'base64')
                                : Buffer.from(''),
                        };
                    }),
                },
                reports: (_a = response.reports) === null || _a === void 0 ? void 0 : _a.map((report) => {
                    return {
                        validator: report.validator,
                        inBeforeResolve: !!report.in_before_resolve,
                        rawReports: report.raw_reports.map((rawReport) => {
                            return {
                                externalID: rawReport.external_id
                                    ? parseInt(rawReport.external_id)
                                    : 0,
                                data: rawReport.data
                                    ? Buffer.from(rawReport.data, 'base64')
                                    : Buffer.from(''),
                            };
                        }),
                    };
                }),
                result: response.result && {
                    requestPacketData: {
                        clientID: response.result.request_packet_data.client_id
                            ? response.result.request_packet_data.client_id
                            : '',
                        askCount: parseInt(response.result.request_packet_data.ask_count),
                        minCount: parseInt(response.result.request_packet_data.min_count),
                        oracleScriptID: parseInt(response.result.request_packet_data.oracle_script_id),
                        calldata: response.result.request_packet_data.calldata
                            ? Buffer.from(response.result.request_packet_data.calldata, 'base64')
                            : Buffer.from(''),
                    },
                    responsePacketData: {
                        requestID: parseInt(response.result.response_packet_data.request_id),
                        requestTime: parseInt(response.result.response_packet_data.request_time),
                        resolveTime: parseInt(response.result.response_packet_data.resolve_time),
                        resolveStatus: response.result.response_packet_data.resolve_status,
                        ansCount: response.result.response_packet_data.ans_count
                            ? parseInt(response.result.response_packet_data.ans_count)
                            : 0,
                        clientID: response.result.response_packet_data.client_id
                            ? response.result.response_packet_data.client_id
                            : '',
                        result: response.result.response_packet_data.result
                            ? Buffer.from(response.result.response_packet_data.result, 'base64')
                            : Buffer.from(''),
                    },
                },
            };
        });
    }
    getRequestIDByTxHash(txHash) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.get(`/txs/${txHash.toString('hex')}`);
            const msgs = response.logs;
            const requestIDs = [];
            msgs.forEach((msg) => {
                const requestEvent = msg.events.filter((event) => event.type == 'request');
                if (requestEvent.length == 1) {
                    const attrID = requestEvent[0].attributes.find(({ key }) => key === 'id').value;
                    requestIDs.push(parseInt(attrID));
                }
            });
            if (requestIDs.length == 0) {
                throw new Error('There is no request message in this tx');
            }
            return requestIDs;
        });
    }
    getRequestEVMProofByRequestID(requestID) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!Number.isInteger(requestID))
                throw Error('requestID is not an integer');
            const response = yield this.getResult(`/oracle/proof/${requestID}`);
            return {
                jsonProof: response.jsonProof,
                evmProofBytes: Buffer.from(response.evmProofBytes, 'hex'),
            };
        });
    }
}
exports.default = Client;
